import {Injectable} from '@angular/core';
import {faCloudArrowUp, faLeftFromBracket, faRightFromBracket, IconDefinition} from "@fortawesome/pro-solid-svg-icons";

export interface WebLessonNotification {
	id?: string,
	message: string,
	icon?: IconDefinition,
	color?: "green" | "red" | "blue",
	on_show?: Function,
	on_close?: Function,
	duration_ms?: number,
}


@Injectable({providedIn: 'root'})
export class WebLessonNotificationService {

	public notification_list: WebLessonNotification[] = [];
	public show = false;

	constructor() {
	}

	get total_count() {
		return this.notification_list.length;
	}

	public add(notification: WebLessonNotification) {
		if(!notification.id) {
			notification.id = Math.random().toString(36).substring(2, 15);
		}

		if (!notification.color) {
			notification.color = "green";
		}

		if (!notification.icon) {
			notification.icon = {
				"green": faRightFromBracket,
				"red": faLeftFromBracket,
				"blue": faCloudArrowUp,
			}[notification.color]
		}
		if (!notification.duration_ms) {
			notification.duration_ms = 1500;
		}

		this.notification_list.unshift(notification);
	}

	public remove_first() {
		let notification = this.notification_list.shift();
	}

	public remove(notification) {
		let index = this.notification_list.indexOf(notification);
		if (index > -1) {
			this.notification_list.splice(index, 1);
		}
	}
}